import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import {flexAbsoluteCenter} from "@pg-design/helpers-css";

import {chartsRoutes} from "../../../../common/app/routing/charts_routes";
import {Content, DropdownLink} from "./dropdown_link/DropdownLink";
import {NavigationText} from "./NavigationText";

interface ILinksProps {
    leftPadding?: boolean;
}

export const Links = ({leftPadding = true}: ILinksProps) => {
    const {t, i18n} = useTranslation();

    return (
        <StyledWrapper leftPadding={leftPadding}>
            <DropdownLink
                to={chartsRoutes[i18n.language].root}
                title={t("nav.solutions")}
                content={Content.Solutions}
            />

            <li css={listItem}>
                <Link css={link} to={chartsRoutes[i18n.language].newshub.marketInformation.root}>
                    <NavigationText variant="info_txt_1">{t("nav.insights")}</NavigationText>
                </Link>
            </li>

            <li css={listItem}>
                <Link css={link} to={chartsRoutes[i18n.language].pricing}>
                    <NavigationText variant="info_txt_1">{t("nav.pricing")}</NavigationText>
                </Link>
            </li>

            <li css={listItem}>
                <Link css={link} to={chartsRoutes[i18n.language].contact}>
                    <NavigationText variant="info_txt_1">{t("nav.contact")}</NavigationText>
                </Link>
            </li>
        </StyledWrapper>
    );
};

const StyledWrapper = styled.ul<{leftPadding: boolean}>`
    display: none;

    @media (min-width: ${(props) => props.theme.breakpoints.lg}) {
        padding-left: ${(props) => props.leftPadding && "4.7rem"};
        padding-right: 1.6rem;
        display: flex;
        align-items: center;
        gap: 1.6rem;
    }
`;

const listItem = css`
    padding-left: 1.6rem;
    height: var(--desktop-header-height);
    ${flexAbsoluteCenter};
`;

const link = css`
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
`;
